import { render, staticRenderFns } from "./activitiesDetail2023hz.vue?vue&type=template&id=a6e7f758&scoped=true"
import script from "./activitiesDetail2023hz.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2023hz.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2023hz.vue?vue&type=style&index=0&id=a6e7f758&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e7f758",
  null
  
)

export default component.exports